import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInternationalDuty = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6371_90851)",
		children: [/* @__PURE__ */ _jsx("path", { d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z" }), /* @__PURE__ */ _jsx("path", {
			d: "M7.55441 9.53613L6.0303 7.05346C6.01538 7.02909 5.99027 7.01294 5.96218 7.00921C5.93409 7.00547 5.90575 7.01442 5.88487 7.03381L4.76623 8.0719C4.73864 8.09751 4.72895 8.13704 4.74113 8.17258L5.03049 9.00933C5.06505 9.10902 5.03546 9.22561 4.95542 9.30566L4.58526 9.67581L3.66522 8.35752C3.66199 8.3528 3.65851 8.34882 3.65453 8.34484C3.65055 8.34086 3.64633 8.33713 3.64185 8.33415L2.32357 7.41411L2.69372 7.04396C2.77401 6.96366 2.8901 6.93408 2.99004 6.96888L3.82679 7.25824C3.86234 7.27042 3.90186 7.26073 3.92747 7.23314L4.96556 6.1145C4.98495 6.09362 4.9939 6.06528 4.99017 6.03719C4.98644 6.0091 4.97028 5.98399 4.94592 5.96907L2.46324 4.44496L2.82221 4.086C2.97211 3.93609 3.17272 3.94281 3.28111 3.96021L6.64754 4.43107C6.67712 4.4353 6.7067 4.4251 6.72783 4.40397L7.53377 3.59804C7.71922 3.41259 7.97576 3.31117 8.23728 3.31962C8.47717 3.32733 8.67157 3.52173 8.67928 3.76162C8.68774 4.02314 8.58631 4.27969 8.40087 4.46514L7.59493 5.27107C7.5738 5.2922 7.56386 5.32203 7.56783 5.35137L8.03896 8.72008C8.05611 8.82623 8.06283 9.02684 7.91292 9.17674L7.55396 9.53571L7.55441 9.53613Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6371_90851",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 12,
			height: 12,
			fill: "currentColor"
		})
	}) })]
});
export default SvgInternationalDuty;
